import React from "react";
import PropTypes from "prop-types";
import FormData from "./FormData";
import HdfStyled from "./HdfStyled";

const HdfComponent = ({ match: { params: { hdfId, planYearId, enrolmentKey } } }) => {
  return (
    <HdfStyled hdfId={hdfId}>
      <FormData hdfId={hdfId} planYearId={planYearId} enrolmentKey={enrolmentKey} />
    </HdfStyled>
  );
};

HdfComponent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      hdfId: PropTypes.string,
      planYearId: PropTypes.string,
      enrolmentKey: PropTypes.string,
    }),
  }),
};

export default HdfComponent;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/index.js